import { gql, useMutation } from '@apollo/client';
import {
  BrandKey,
  OrphanPageStatus,
  UpsertOrphanPageMutation,
  UpsertOrphanPageMutationVariables,
} from '../../../__generated__/queries-web';

const UPSERT_ORPHANPAGE = gql`
  mutation upsertOrphanPage(
    $where: OrphanPageUniqueFilterInput!
    $update: OrphanPageUpdateInput!
    $create: OrphanPageCreationInput!
  ) {
    upsertOrphanPage(where: $where, update: $update, create: $create) {
      id
      publishedAt
      editedAt
      status
      title
      content
      metas
      isCMPEnabled
      isAdsEnabled
      isFullScreen
      brandKey
      uri
    }
  }
`;

interface upsertOrphanPageProps {
  id: string;
  metas?: string[];
  title: string;
  content: string;
  isCMPEnabled: boolean;
  isAdsEnabled: boolean;
  isFullScreen: boolean;
  uri: string;
  brandKey?: BrandKey;
  status: OrphanPageStatus;
  publishedAt?: string | null;
}

export const prepareUpsertVariable = (
  props: upsertOrphanPageProps,
): UpsertOrphanPageMutationVariables => {
  const { id, brandKey, ...rest } = props;
  if (!brandKey) {
    throw new Error('brandKey is required for orphan page creation');
  }
  return {
    create: {
      id,
      brandKey,
      ...rest,
    },
    update: { ...rest },
    where: { id },
  };
};

export const useUpsertOrphanPage = () =>
  useMutation<UpsertOrphanPageMutation, UpsertOrphanPageMutationVariables>(
    UPSERT_ORPHANPAGE,
  );
